import { axiosInstance } from '../Api';
import {IFWEPoint} from "./FileEndPoint";

export default class FWEPoint {
  endPoint = 'Point';

  async getFWEPoints(): Promise<IFWEPoint[]> {
    try {
      const r = await axiosInstance.get<IFWEPoint[]>(`/${this.endPoint}/GetFweOutputPoints`);
      if (!r.data) {
        return [];
      }
      return r.data;
    } catch (error: unknown) {
      console.error('Error fetching FWE points:', error);
      return [];
    }
  }
}
